"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _IconComponent = _interopRequireDefault(require("./utils/IconComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function TirePressure(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return _react["default"].createElement(_IconComponent["default"], _extends({
    name: "tire-pressure",
    size: "".concat(size),
    viewboxSize: "512"
  }, props), _react["default"].createElement("g", null, _react["default"].createElement("g", {
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("circle", {
    "class": "icon-bg",
    fill: "#FFF",
    cx: "232",
    cy: "158",
    r: "143"
  }), _react["default"].createElement("path", {
    d: "M285.098 289.914v61.503H179.496v-61.503h105.602zm13.218-188.429s-20.81 55.022-40.81 77.022c0 0-21.5 23-44.648.954 0 0-16.693-21.455 5.36-39.454 22.054-17.999 80.098-38.522 80.098-38.522z",
    "class": "icon-fill",
    fill: "#2CD5C4"
  }), _react["default"].createElement("path", {
    d: "M223.506 170.232c3.777 3.319 7.396 4.869 11.01 4.78 6.54-.19 12.342-5.654 12.742-6.044 8.379-9.277 17.585-26.392 25.023-42.197-17.043 7.29-35.681 16.306-45.21 24.083-6.518 5.319-6.651 9.778-6.04 13.069.522 2.796 1.814 5.21 2.475 6.309M232.225 1C318.919 1 389.45 71.53 389.45 158.224c0 62.767-36.97 117.06-90.278 142.25l-.002 56.946c0 7.775-6.304 14.077-14.077 14.077h-38.72v79.086c0 18.2 15.09 33.007 33.64 33.007 18.549 0 33.643-14.807 33.643-33.007V440.51c0-7.628 6.302-13.812 14.077-13.812 7.772 0 14.076 6.184 14.076 13.812v10.073c0 33.43-27.721 60.63-61.795 60.63-34.073 0-61.795-27.199-61.795-60.63v-79.087l-38.721.001c-7.773 0-14.077-6.302-14.077-14.077v-62.678a13.94 13.94 0 01.556-8.729c2.876-7.177 11.027-10.664 18.203-7.787 15.27 6.12 31.435 9.223 48.045 9.223 71.255 0 129.225-57.97 129.225-129.225S303.48 29 232.225 29 103 86.97 103 158.224c0 30.875 11.062 60.758 31.148 84.145 5.037 5.865 4.366 14.704-1.5 19.742-5.865 5.038-14.703 4.365-19.742-1.5C88.462 232.151 75 195.79 75 158.224 75 71.53 145.53 1 232.225 1zm143.224 285.722c34.074 0 61.795 27.72 61.795 61.794v74.777c0 7.774-6.301 14.077-14.076 14.077-7.773 0-14.077-6.303-14.077-14.077v-74.777c0-18.549-15.093-33.64-33.641-33.64s-33.642 15.09-33.642 33.64v17.414c0 7.774-6.303 14.077-14.077 14.077-7.773 0-14.077-6.302-14.077-14.077v-17.414c0-34.074 27.721-61.794 61.795-61.794zM232.225 315.45c-13.158 0-26.091-1.604-38.651-4.783v32.678h77.441l.002-32.737a156.996 156.996 0 01-38.792 4.842zm76.098-223.754a13.997 13.997 0 013.088 14.743c-.887 2.349-22 57.787-43.545 81.486l-.131.144c-1.376 1.472-13.977 14.398-32.405 14.934-.366.01-.742.016-1.126.016-7.973 0-19.481-2.448-31.001-13.42a13.95 13.95 0 01-1.394-1.54c-10.086-12.963-16.397-39.347 7.557-58.897 23.67-19.318 81.82-40.003 84.284-40.874a13.999 13.999 0 0114.673 3.408z",
    "class": "icon-outline",
    fill: "#1436B8"
  }))));
}

TirePressure.defaultProps = {
  size: 30
};
var _default = TirePressure;
exports["default"] = _default;